import React, { useState, useEffect } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import FormularioVendaProduto from '../Formulario/FormularioVendaProduto';
import ImportacaoProdutos from './ImportacaoProdutos';
import PopupPagamentoExterno from '../components/PopupPagamentoExterno';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

// Helper: listens for MobileFooter generic + event
function MobileAddListener({ onOpen }) {
  useEffect(() => {
    window.addEventListener('open-mobile-add-popup', onOpen);
    return () => window.removeEventListener('open-mobile-add-popup', onOpen);
  }, [onOpen]);
  return null;
}

export default function VendasProdutosDropdown() {
  const gerarUidItem = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const [vendasProdutos, setVendasProdutos] = useState([]);
  const [vendasFiltradas, setVendasFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showImportModal, setShowImportModal] = useState(false);
  // Pop-up de pagamento externo (id da venda) | null
  const [pagamentoExternoVendaId, setPagamentoExternoVendaId] = useState(null);
  
  // Estados para filtro
  const [filtro, setFiltro] = useState('vendaId');
  const [valorFiltro, setValorFiltro] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);

  // Estados para popups
  const [showPopupProdutos, setShowPopupProdutos] = useState(false);
  const [showFormularioVenda, setShowFormularioVenda] = useState(false);
  const [showFormularioEdicao, setShowFormularioEdicao] = useState(false);
  const [vendaEdicao, setVendaEdicao] = useState(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  // Itens da venda (carrinho) - suporta múltiplos produtos
  const [vendaItems, setVendaItems] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [loadingProdutos, setLoadingProdutos] = useState(false);
  
  // Estados para dados de apoio
  const [clientes, setClientes] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [tiposPagamento, setTiposPagamento] = useState([]);

  // Opções de filtro
  const opcoesFiltro = [
    { valor: 'vendaId', label: 'ID da Venda' },
    { valor: 'clienteId', label: 'ID do Cliente' },
    { valor: 'clienteNome', label: 'Nome do Cliente' },
    { valor: 'produtoId', label: 'ID do Produto' },
    { valor: 'produtoNome', label: 'Nome do Produto' }
  ];

  useEffect(() => {
    fetchVendasProdutos();
    // Carregar dados de apoio na inicialização
    fetchClientes();
    fetchVendedores();
    fetchTiposPagamento();
  }, []);

  // Notifica AjudaWidget quando o formulário de venda de produto abre/fecha
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('vendas-produtos-popup-state', {
      detail: { formularioAberto: showFormularioVenda || showFormularioEdicao }
    }));
  }, [showFormularioVenda, showFormularioEdicao]);

  // Fecha todos os popups quando AjudaWidget solicitar
  useEffect(() => {
    const handler = () => {
      setShowFormularioVenda(false);
      setShowFormularioEdicao(false);
      setShowPopupProdutos(false);
      setShowImportModal(false);
      setDropdownAberto(false);
      setVendaEdicao(null);
      setProdutoSelecionado(null);
      setVendaItems([]);
    };
    window.addEventListener('vendas-produtos-fechar-todos-popups', handler);
    return () => window.removeEventListener('vendas-produtos-fechar-todos-popups', handler);
  }, []);

  // Lista de possíveis bases da API (usada por apiCall e pelo modal de importação)
  const apiUrls = [
    `${BASE_URL}/`,
    `${BASE_URL}/`,
    `${BASE_URL}/`
  ];

  // Função para fazer chamadas da API com fallback de URLs
  const apiCall = async (endpoint, options = {}) => {
    for (const base of apiUrls) {
      const url = `${base}${endpoint}`;
      try {
        console.log(`Tentando conectar em: ${url}`);
        const token = getAuthToken();
        if (token) {
          options = { ...options };
          options.headers = { ...options.headers, Authorization: options.headers?.Authorization || `Bearer ${token}` };
        }
        const response = await fetch(url, options);
        if (response.ok) {
          console.log(`✅ Sucesso em: ${url}`);
          // Tentar parsear JSON, quando aplicável
          const contentType = response.headers.get('content-type') || '';
          if (contentType.includes('application/json') || contentType.includes('text/json')) {
            return await response.json();
          }
          // Caso não seja JSON, retornar blob/text conforme necessidade
          return await response.text();
        }
        console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
      }
    }
    
    throw new Error('Nenhuma URL da API funcionou. Verifique se o backend está rodando.');
  };

  const fetchVendasProdutos = async () => {
    try {
      setLoading(true);
      console.log('🔄 Iniciando busca de vendas de produtos...');
      
      // Buscar TODAS as vendas
      const data = await apiCall('Vendas');
      console.log('📊 Resposta da API Vendas:', data);
      console.log('📊 Tipo de resposta:', typeof data);
      console.log('📊 É array?:', Array.isArray(data));
      
      const vendasArray = Array.isArray(data) ? data : [];
      console.log('📊 Vendas como array:', vendasArray.length, 'itens');
      
      if (vendasArray.length > 0) {
        console.log('📊 Exemplo de venda (primeira):', vendasArray[0]);
        console.log('💰 TODOS os campos de valor disponíveis:', {
          // Campos originais
          valorVenda: vendasArray[0].valorVenda,
          ValorVenda: vendasArray[0].ValorVenda,
          valor_venda: vendasArray[0].valor_venda,
          // Campos de valor final
          valorFinal: vendasArray[0].valorFinal,
          ValorFinal: vendasArray[0].ValorFinal,
          valor_final: vendasArray[0].valor_final,
          // Campos de valor com juros
          valorComJuros: vendasArray[0].valorComJuros,
          ValorComJuros: vendasArray[0].ValorComJuros,
          valor_com_juros: vendasArray[0].valor_com_juros,
          // Campos de valor total
          valorTotal: vendasArray[0].valorTotal,
          ValorTotal: vendasArray[0].ValorTotal,
          valor_total: vendasArray[0].valor_total,
          // Campos de orçamento (NÃO usar)
          valorOrc: vendasArray[0].valorOrc,
          ValorOrc: vendasArray[0].ValorOrc,
          // Campos de juros separados
          valorJuros: vendasArray[0].valorJuros,
          ValorJuros: vendasArray[0].ValorJuros
        });
      }
      
      // 🎯 FILTRO: Apenas vendas de produto (TipoVendaId = 1)
      const vendasDeProduto = vendasArray.filter(venda => {
        const tipoVendaId = venda.tipoVendaId || venda.TipoVendaId;
        
        // Critério: TipoVendaId = 1 (vendas de produtos)
        const ehVendaDeProduto = tipoVendaId === 1;
        
        console.log(`🔍 Venda ${venda.id || venda.Id}:`, {
          tipoVendaId,
          ehVendaDeProduto
        });
        
        return ehVendaDeProduto;
      });
      
      console.log(`🔍 Filtro aplicado: ${vendasArray.length} vendas totais → ${vendasDeProduto.length} vendas de produtos (TipoVendaId = 1)`);
      
      setVendasProdutos(vendasDeProduto);
      setVendasFiltradas(vendasDeProduto);
      setError('');
    } catch (err) {
      console.error('Erro ao buscar vendas de produtos:', err);
      setError('Erro ao carregar vendas de produtos. Verifique se o backend está rodando.');
      setVendasProdutos([]);
      setVendasFiltradas([]);
    } finally {
      setLoading(false);
    }
  };

  // Funções de filtro
  const handleFiltroChange = (novoFiltro) => {
    setFiltro(novoFiltro);
    setDropdownAberto(false);
    setValorFiltro('');
    // Resetar para todas as vendas quando muda o filtro
    setVendasFiltradas(vendasProdutos);
  };

  const handleInputChange = (e) => {
    const valor = e.target.value;
    setValorFiltro(valor);
    aplicarFiltro(valor);
  };

  const aplicarFiltro = (valor) => {
    if (!valor.trim()) {
      setVendasFiltradas(vendasProdutos);
      return;
    }

    const filtradas = vendasProdutos.filter(venda => {
      if (filtro === 'vendaId') {
        return venda.id && venda.id.toString().includes(valor);
      }
      if (filtro === 'clienteId') {
        return venda.clineteId && venda.clineteId.toString().includes(valor);
      }
      if (filtro === 'clienteNome') {
        return venda.nomeCliente && venda.nomeCliente.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'produtoId') {
        return venda.produtoId && venda.produtoId.toString().includes(valor);
      }
      if (filtro === 'produtoNome') {
        return venda.nomeProduto && venda.nomeProduto.toLowerCase().includes(valor.toLowerCase());
      }
      return false;
    });

    setVendasFiltradas(filtradas);
  };

  const limparFiltro = () => {
    setValorFiltro('');
    setVendasFiltradas(vendasProdutos);
  };

  // Função para aprovar venda e gerar contas a receber automaticamente
  const aprovarVenda = async (vendaId) => {
    try {
      console.log(`🔄 Aprovando venda de produto ${vendaId}...`);
      
      const response = await apiCall(`Vendas/aprovar/${vendaId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ Venda aprovada com sucesso!');
      
      // Recarregar as vendas para atualizar o status
      await fetchVendasProdutos();
      
      alert('Venda aprovada com sucesso! Contas a receber geradas automaticamente.');
      
    } catch (error) {
      console.error('❌ Erro ao aprovar venda:', error);
      alert('Erro ao aprovar venda. Tente novamente.');
    }
  };

  // Função para buscar dados de uma venda específica para edição
  const fetchVendaPorId = async (vendaId) => {
    try {
      console.log('🔍 Buscando dados da venda:', vendaId);
      const data = await apiCall(`Vendas/${vendaId}`);
      console.log('📊 Dados da venda recebidos:', data);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar dados da venda:', error);
      alert('Erro ao buscar dados da venda. Tente novamente.');
      return null;
    }
  };

  // Função para buscar dados completos de um produto por ID
  const fetchProdutoPorId = async (produtoId) => {
    try {
      console.log('🔍 Buscando dados completos do produto:', produtoId);
      const data = await apiCall(`Produto/${produtoId}`);
      console.log('📦 Dados completos do produto recebidos:', data);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar dados do produto:', error);
      alert('Erro ao buscar dados do produto. Tente novamente.');
      return null;
    }
  };

  // Função para abrir formulário de edição
  const abrirFormularioEdicao = async (venda) => {
    try {
      console.log('🔄 Abrindo formulário de edição para venda:', venda.id);
      
      // Carregar dados de apoio (clientes, vendedores, tipos de pagamento)
      console.log('📋 Carregando dados de apoio...');
      await Promise.all([
        fetchClientes(),
        fetchVendedores(),
        fetchTiposPagamento()
      ]);
      console.log('✅ Dados de apoio carregados');
      
      // Buscar dados completos da venda (esperamos que o backend retorne Items[])
      const dadosVenda = await fetchVendaPorId(venda.id);

      if (dadosVenda) {
        console.log('✅ Dados da venda carregados:', dadosVenda);

        // Extrair Items com tolerância a variações de nome de propriedade
        const rawItems = dadosVenda.Items ?? dadosVenda.items ?? dadosVenda.produtoItems ?? [];

        // Mapear itens do backend para o formato esperado pelo formulário
        const mappedItems = Array.isArray(rawItems) ? rawItems.map(it => {
          const precoUnit = it.ValorUnitario ?? it.valorUnitario ?? it.precoUnitario ?? it.PrecoUnitario ?? 0;
          const quantidade = it.Quantidade ?? it.quantidade ?? it.qtd ?? it.Qtd ?? 1;
          const produtoId = it.ProdutoId ?? it.produtoId ?? undefined;
          return {
            id: it.Id ?? it.id ?? undefined,
            ProdutoId: produtoId,
            produtoId: produtoId,
            NomeProduto: it.NomeProduto ?? it.nomeProduto ?? it.nome ?? it.ProdutoNome ?? '',
            nome: it.NomeProduto ?? it.nomeProduto ?? it.nome ?? it.ProdutoNome ?? '',
            precoUnitario: precoUnit,
            quantidade: quantidade,
            ValorTotal: it.ValorTotal ?? it.valorTotal ?? (precoUnit * quantidade),
            _uid: `${produtoId || 'item'}-${it.Id ?? it.id ?? gerarUidItem()}`
          };
        }) : [];

        // Se houver itens, popular o estado vendaItems para abrir o formulário já com múltiplos produtos
        if (mappedItems.length > 0) {
          setVendaItems(mappedItems);
          // Também definir um produto selecionado básico a partir do primeiro item (útil para alguns campos do formulário)
          setProdutoSelecionado({
            id: mappedItems[0].ProdutoId || mappedItems[0].id,
            nome: mappedItems[0].nome || mappedItems[0].NomeProduto
          });
        } else {
          // Fallback: se não houver Items, tentar buscar produtoId único como antes
          const produtoId = dadosVenda.produtoId || dadosVenda.ProdutoId;
          if (produtoId) {
            const dadosProduto = await fetchProdutoPorId(produtoId);
            if (dadosProduto) {
              console.log('✅ Dados do produto carregados (fallback):', dadosProduto);
              setProdutoSelecionado(dadosProduto);
            }
          }
        }

        setVendaEdicao(dadosVenda);
        setShowFormularioEdicao(true);
      }
    } catch (error) {
      console.error('❌ Erro ao abrir formulário de edição:', error);
      alert('Erro ao abrir formulário de edição. Tente novamente.');
    }
  };

  // Função para buscar produtos
  const fetchProdutos = async () => {
    try {
      setLoadingProdutos(true);
      const data = await apiCall('Produto');
      setProdutos(data);
    } catch (err) {
      console.error('Erro ao buscar produtos:', err);
      setProdutos([]);
    } finally {
      setLoadingProdutos(false);
    }
  };

  // Função para buscar clientes
  const fetchClientes = async () => {
    try {
      const data = await apiCall('Cliente');
      setClientes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Erro ao buscar clientes:', err);
      setClientes([]);
    }
  };

  // Função para buscar vendedores
  const fetchVendedores = async () => {
    try {
      const data = await apiCall('Vendedor');
      setVendedores(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Erro ao buscar vendedores:', err);
      setVendedores([]);
    }
  };

  // Função para buscar tipos de pagamento
  const fetchTiposPagamento = async () => {
    try {
      // Tentar diferentes endpoints para tipos de pagamento
      let data = await apiCall('TipoPagamento');
      console.log('🔍 Dados recebidos de TipoPagamento:', data);
      
      if (!data || !Array.isArray(data) || data.length === 0) {
        data = await apiCall('Tipo_pagamento');
        console.log('🔍 Dados recebidos de Tipo_pagamento:', data);
      }
      
      setTiposPagamento(Array.isArray(data) ? data : []);
      console.log('✅ Tipos de pagamento definidos:', Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Erro ao buscar tipos de pagamento:', err);
      setTiposPagamento([]);
    }
  };

  // Função para abrir popup de seleção de produtos
  const handleNovaVenda = () => {
    // Novo comportamento: não abrir mais o popup de seleção.
    // Em vez disso, abrir diretamente o formulário de venda de produto com um produto padrão
    // (venda direta), assim o usuário já vê o formulário sem precisar escolher um produto.
    // Mantemos as funções de fetch de dados de apoio.
    const produtoPadrao = {
      id: null,
      nome: 'Venda direta',
      preco: 0,
      estoque: 0
    };
    // iniciar venda com carrinho vazio
    setVendaItems([]);
    setProdutoSelecionado(produtoPadrao);
    setShowFormularioVenda(true);
    // carregar dados de apoio
    fetchClientes();
    fetchVendedores();
    fetchTiposPagamento();
  };

  // Função para escolher produto e abrir formulário
  const handleEscolherProduto = (produto) => {
    const novoItem = {
      produtoId: produto.id,
      ProdutoId: produto.id,
      nome: produto.nome,
      precoUnitario: parseFloat(produto.preco || 0),
      quantidade: 1,
      estoque: produto.estoque || produto.Estoque || 0,
      _uid: gerarUidItem()
    };

    // Se o formulário já está aberto (criação ou edição), apenas atualiza o carrinho local
    if (showFormularioVenda || showFormularioEdicao) {
      setVendaItems(prev => {
        const listaAtual = Array.isArray(prev) ? prev : [];
        const idxExistente = listaAtual.findIndex(it => (it.produtoId || it.ProdutoId) === novoItem.produtoId);
        if (idxExistente >= 0) {
          // Se já existe no carrinho, só incrementa quantidade
          return listaAtual.map((it, idx) => {
            if (idx !== idxExistente) return it;
            const qtdAtual = parseInt(it.quantidade || it.Quantidade || 1) || 1;
            return {
              ...it,
              quantidade: qtdAtual + 1
            };
          });
        }
        // Produto novo: adiciona sem mexer nos demais
        return [...listaAtual, novoItem];
      });
      setShowPopupProdutos(false);
      return;
    }

    // Caso contrário, comportamento antigo: abrir formulário com produto selecionado
    setProdutoSelecionado(produto);
    setVendaItems([novoItem]);
    setShowPopupProdutos(false);
    setShowFormularioVenda(true);
  };

  return (
    <div className="container-geral fundo-branco" style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '20px'
    }}>
      
      <MobileAddListener onOpen={handleNovaVenda} />

      {/* Botão Nova Venda de Produto */}
      <div className="vendas-header" style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
        <div style={{ display: 'flex', gap: 12 }}>
        <button
          className="btn-nova-venda-produto"
          style={{
            background: 'rgb(235, 133, 0)',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            padding: '16px 32px',
            fontSize: 20,
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            transition: 'background 0.2s'
          }}
          onMouseEnter={e => e.target.style.background = 'rgb(208, 116, 0)'}
          onMouseLeave={e => e.target.style.background = 'rgb(235, 133, 0)'}
          onClick={handleNovaVenda}
        >
          Nova Venda
        </button>
        <button
          className="btn-importar-produtos"
          style={{
            background: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            padding: '14px 20px',
            fontSize: 16,
            fontWeight: '700',
            cursor: 'pointer'
          }}
          onClick={() => setShowImportModal(true)}
        >
          Importar Produtos
        </button>
        </div>
      </div>

      {/* Filtro de vendas de produtos */}
      <div className="vendas-filtro-container" style={{
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto 24px auto',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        padding: '0 20px',
        justifyContent: 'center'
      }}>
        <label style={{ 
          color: '#333', 
          fontSize: '16px', 
          fontWeight: '500',
          whiteSpace: 'nowrap'
        }}>
          Filtrar por:
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <input
              type="text"
              style={{
                padding: '10px 15px',
                paddingRight: valorFiltro ? '40px' : '15px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '14px',
                minWidth: '250px',
                outline: 'none'
              }}
              placeholder={`Filtrar por ${opcoesFiltro.find(opcao => opcao.valor === filtro)?.label || 'campo'}`}
              value={valorFiltro}
              onChange={handleInputChange}
            />
            {valorFiltro && (
              <button
                onClick={limparFiltro}
                title="Limpar filtro"
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  color: 'rgb(235, 133, 0)',
                  border: 'none',
                  width: '20px',
                  height: '20px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  lineHeight: '1',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  outline: 'none',
                  boxShadow: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                }}
                onFocus={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                  e.target.style.outline = 'none';
                }}
              >
                ×
              </button>
            )}
          </div>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setDropdownAberto(!dropdownAberto)}
              style={{
                padding: '10px 15px',
                backgroundColor: 'rgb(235, 133, 0)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '200px',
                justifyContent: 'space-between'
              }}
            >
              {opcoesFiltro.find(opcao => opcao.valor === filtro)?.label || 'Selecione'}
              <span style={{ transform: dropdownAberto ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
            </button>
            {dropdownAberto && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'rgb(235, 133, 0)',
                border: '1px solid rgb(235, 133, 0)',
                borderRadius: '5px',
                marginTop: '2px',
                zIndex: 1000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                {opcoesFiltro.map(opcao => (
                  <div 
                    key={opcao.valor}
                    onClick={() => handleFiltroChange(opcao.valor)}
                    style={{ 
                      padding: '10px 15px', 
                      cursor: 'pointer',
                      borderBottom: '1px solid rgba(255,255,255,0.2)',
                      color: 'white'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    {opcao.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loading */}
      {loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          color: '#666',
          backgroundColor: 'white',
          marginTop: '10px'
        }}>
          Carregando vendas de produtos...
        </div>
      )}

      {/* Error */}
      {error && !loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          color: '#d32f2f',
          backgroundColor: 'white',
          marginTop: '10px'
        }}>
          {error}
        </div>
      )}

      {/* Lista de vendas de produtos */}
      {!loading && !error && (
        <div className="lista-clientes">
          {vendasFiltradas.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '40px', 
              color: '#666',
              backgroundColor: 'white',
              borderRadius: '8px'
            }}>
              {valorFiltro ? 'Nenhuma venda de produto encontrada com este filtro.' : 'Nenhuma venda de produto cadastrada.'}
            </div>
          ) : (
            vendasFiltradas.map((venda) => (
              <div
                key={venda.id}
                className="venda-produto-card"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  padding: '15px',
                  margin: '5px 0',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  minHeight: '80px',
                  borderBottom: '1px solid #ddd'
                }}
              >
                {/* Bloco de dados em linha */}
                <div className="venda-produto-card-fields" style={{ display: 'flex', flexDirection: 'row', gap: 20, flex: 1 }}>
                  
                  {/* ID da Venda */}
                  <div className="venda-field venda-field-id" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>ID Venda</span>
                    <span style={{ fontSize: 16 }}>{venda.id}</span>
                  </div>
                  
                  {/* ID do Cliente */}
                  <div className="venda-field venda-field-cliente-id" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>ID Cliente</span>
                    <span style={{ fontSize: 16 }}>{venda.clienteId || venda.clineteId || 'N/A'}</span>
                  </div>
                  
                  {/* Nome do Cliente */}
                  <div className="venda-field venda-field-cliente" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>Cliente</span>
                    <div style={{ fontSize: 16, maxWidth: '150px', wordWrap: 'break-word' }}>
                      {venda.nomeCliente || 'N/A'}
                    </div>
                  </div>
                  
                  {/* Valor */}
                  <div className="venda-field venda-field-valor" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>Valor Final</span>
                    <span style={{ fontSize: 16, color: '#2e7d32', fontWeight: '600' }}>
                      {(() => {
                        // Com pagamento externo, o valor da venda é o final menos o que foi pago por fora
                        const pagoExterno = Number(venda.valorPagoExterno ?? venda.ValorPagoExterno ?? 0);
                        if (pagoExterno > 0) {
                          const aPagar = Math.max(0, Number(venda.valorAPagar ?? venda.ValorAPagar ?? 0));
                          return (
                            <>
                              {`R$ ${aPagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
                              <span style={{ display: 'block', fontSize: 11, color: '#1565c0', fontWeight: 600 }}>
                                {aPagar <= 0 ? 'pago por fora' : `− R$ ${pagoExterno.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} pago por fora`}
                              </span>
                            </>
                          );
                        }
                        // Buscar VALOR FINAL da tabela (com juros inclusos), não valor original
                        const valorFinal = venda.valorFinal || venda.ValorFinal || venda.valor_final || 
                                         venda.valorComJuros || venda.ValorComJuros || venda.valor_com_juros ||
                                         venda.valorTotal || venda.ValorTotal || venda.valor_total ||
                                         // Fallback para valor original apenas se não houver valor final
                                         venda.valorVenda || venda.ValorVenda || 0;
                        
                        return valorFinal > 0 ? `R$ ${parseFloat(valorFinal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : 'R$ 0,00';
                      })()}
                    </span>
                  </div>
                  
                  {/* Status */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>Status</span>
                    <span style={{ 
                      fontSize: 14, 
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: venda.statusVenda?.toLowerCase().includes('aprovado') ? '#c8e6c9' : 
                                     venda.statusVenda?.toLowerCase().includes('pendente') ? '#fff3e0' : 
                                     venda.statusVenda?.toLowerCase().includes('rejeitado') ? '#ffcdd2' : '#f5f5f5',
                      color: venda.statusVenda?.toLowerCase().includes('aprovado') ? '#2e7d32' : 
                             venda.statusVenda?.toLowerCase().includes('pendente') ? 'rgb(208, 116, 0)' : 
                             venda.statusVenda?.toLowerCase().includes('rejeitado') ? '#d32f2f' : '#666'
                    }}>
                      {venda.statusVenda || 'Pendente'}
                    </span>
                  </div>
                  
                  {/* Data Venda */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, color: '#444', fontSize: 15, marginBottom: 2 }}>Data Venda</span>
                    <span style={{ fontSize: 16 }}>
                      {venda.dataVenda ? (() => {
                        try {
                          const data = new Date(venda.dataVenda);
                          return data.toLocaleDateString('pt-BR');
                        } catch {
                          return venda.dataVenda.split('T')[0] || venda.dataVenda;
                        }
                      })() : 'N/A'}
                    </span>
                  </div>
                </div>
                
                {/* Botão de Ação - Mais próximo */}
                <div className="venda-card-actions" style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 15, flexWrap: 'wrap' }}>
                  {/* Pagamento feito fora do sistema (total ou parcial) */}
                  {!/cancel/i.test(venda.statusVenda || '') && (
                    <button
                      type="button"
                      onClick={() => setPagamentoExternoVendaId(venda.id || venda.Id)}
                      title="Registrar um pagamento feito fora do sistema"
                      style={{ background: '#fff', color: 'rgb(235, 133, 0)', border: '2px solid rgb(235, 133, 0)', borderRadius: 8, padding: '10px 14px', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
                    >
                      💵 Pagamento externo
                    </button>
                  )}
                  <button
                    style={{
                      background: 'rgb(235, 133, 0)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '12px 20px',
                      fontWeight: 700,
                      fontSize: 15,
                      cursor: 'pointer',
                      boxShadow: '0 3px 10px rgba(235, 133, 0, 0.27)',
                      transition: 'background 0.18s',
                      minWidth: '100px'
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgb(208, 116, 0)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'rgb(235, 133, 0)'}
                    onClick={() => abrirFormularioEdicao(venda)}
                    title="Editar venda"
                  >
                    <span className="btn-edit-icon" aria-hidden>
                      ✎
                    </span>
                    <span className="btn-edit-text">
                      Editar
                    </span>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {pagamentoExternoVendaId && (
        <PopupPagamentoExterno
          vendaId={pagamentoExternoVendaId}
          onFechar={() => setPagamentoExternoVendaId(null)}
          onSalvo={() => fetchVendasProdutos()}
        />
      )}

      {/* Popup de seleção de produtos */}
      {showPopupProdutos && (
        <div className="popup-agendamento-overlay" onClick={() => setShowPopupProdutos(false)} style={{ position: 'fixed', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 'calc(var(--z-popup) + 10)', background: 'rgba(0,0,0,0.35)' }}>
          <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative', maxWidth: '800px' }}>
            <button
              onClick={() => setShowPopupProdutos(false)}
              aria-label="Fechar"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: 'rgb(235, 133, 0)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
              }}
            >
              ×
            </button>
            <div className="popup-agendamento-centro">
              <div className="popup-titulo-laranja">
                Selecionar Produto
              </div>
              
              <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '20px 0' }}>
                {loadingProdutos ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    Carregando produtos...
                  </div>
                ) : produtos.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    Nenhum produto cadastrado.
                  </div>
                ) : (
                  produtos.map((produto) => {
                    const semEstoque = !produto.estoque || produto.estoque <= 0;
                    return (
                      <div key={produto.id}>
                        <div style={{ 
                          display: 'flex', 
                          borderBottom: semEstoque ? 'none' : '1px solid #ddd',
                          padding: '15px 0',
                          alignItems: 'center',
                          opacity: semEstoque ? 0.6 : 1
                        }}>
                          {/* Container de dados */}
                          <div style={{ width: '75%', display: 'flex', flexDirection: 'row', gap: '20px' }}>
                            <div style={{ minWidth: '80px' }}>
                              <label style={{ fontWeight: 'bold', fontSize: '14px', color: 'rgb(235, 133, 0)' }}>ID:</label>
                              <div style={{ fontSize: '14px' }}>{produto.id}</div>
                            </div>
                            <div style={{ minWidth: '150px' }}>
                              <label style={{ fontWeight: 'bold', fontSize: '14px', color: 'rgb(235, 133, 0)' }}>Nome:</label>
                              <div style={{ fontSize: '14px' }}>{produto.nome}</div>
                            </div>
                            <div style={{ minWidth: '100px' }}>
                              <label style={{ fontWeight: 'bold', fontSize: '14px', color: 'rgb(235, 133, 0)' }}>Preço:</label>
                              <div style={{ fontSize: '14px' }}>
                                {produto.preco ? 
                                  `R$ ${produto.preco.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` 
                                  : 'N/A'
                                }
                              </div>
                            </div>
                            <div style={{ minWidth: '80px' }}>
                              <label style={{ fontWeight: 'bold', fontSize: '14px', color: semEstoque ? '#f44336' : 'rgb(235, 133, 0)' }}>Estoque:</label>
                              <div style={{ 
                                fontSize: '14px', 
                                fontWeight: semEstoque ? 'bold' : 'normal',
                                color: semEstoque ? '#f44336' : 'inherit'
                              }}>
                                {produto.estoque || 0}
                              </div>
                            </div>
                          </div>
                          
                          {/* Container do botão */}
                          <div style={{ width: '25%', display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                              onClick={() => {
                                if (semEstoque) {
                                  alert('⚠️ Este produto não possui estoque disponível!');
                                  return;
                                }
                                handleEscolherProduto(produto);
                              }}
                              disabled={semEstoque}
                              style={{
                                backgroundColor: semEstoque ? '#ccc' : 'rgb(235, 133, 0)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '8px 16px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                cursor: semEstoque ? 'not-allowed' : 'pointer',
                                opacity: semEstoque ? 0.5 : 1
                              }}
                            >
                              {semEstoque ? 'Sem Estoque' : 'Escolher Produto'}
                            </button>
                          </div>
                        </div>
                        
                        {/* Mensagem de erro abaixo do card quando sem estoque */}
                        {semEstoque && (
                          <div style={{
                            backgroundColor: '#ffebee',
                            border: '1px solid #f44336',
                            borderRadius: '4px',
                            padding: '10px',
                            marginBottom: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span style={{ fontSize: '18px', color: '#f44336' }}>⚠️</span>
                            <span style={{ color: '#d32f2f', fontSize: '13px', fontWeight: '500' }}>
                              Este produto não possui estoque disponível
                            </span>
                          </div>
                        )}
                        
                        {!semEstoque && (
                          <div style={{ borderBottom: '1px solid #ddd', marginBottom: '0' }} />
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Popup de formulário de venda */}
      {showFormularioVenda && (
        <FormularioVendaProduto
          produtoSelecionado={produtoSelecionado}
          vendaItems={vendaItems}
          onAdicionarItem={(item) => setVendaItems(prev => ([...prev, item]))}
          onAtualizarItem={(index, item) => setVendaItems(prev => prev.map((it,i) => (item?._uid ? it._uid === item._uid : i===index) ? item : it))}
          onRemoverItem={(index, item) => setVendaItems(prev => prev.filter((it, i) => item?._uid ? it._uid !== item._uid : i !== index))}
          clientes={clientes}
          vendedores={vendedores}
          tiposPagamento={tiposPagamento}
          onSalvar={() => {
            setShowFormularioVenda(false);
            setProdutoSelecionado(null);
            setVendaItems([]);
            fetchVendasProdutos(); // Recarregar lista
          }}
          onCancelar={() => {
            setShowFormularioVenda(false);
            setProdutoSelecionado(null);
            setVendaItems([]);
          }}
          onAbrirPopupProdutos={() => {
            // Abrir popup de seleção de produtos a partir do formulário
            fetchProdutos();
            setShowPopupProdutos(true);
          }}
        />
      )}

      {showImportModal && (
        <ImportacaoProdutos
          apiBases={apiUrls}
          onClose={() => setShowImportModal(false)}
          onImportSuccess={(resultado) => {
            setShowImportModal(false);
            // após importação bem-sucedida, recarregar produtos e vendas
            fetchProdutos();
            fetchVendasProdutos();
            alert(resultado.Mensagem || 'Importação concluída');
          }}
        />
      )}

      {/* Popup de edição de venda */}
      {showFormularioEdicao && vendaEdicao && (
        <FormularioVendaProduto
          produtoSelecionado={produtoSelecionado || {
            id: vendaEdicao.produtoId || vendaEdicao.ProdutoId,
            nome: vendaEdicao.nomeProduto || vendaEdicao.NomeProduto
          }}
          vendaItems={vendaItems}
          onAdicionarItem={(item) => setVendaItems(prev => ([...prev, item]))}
          onAtualizarItem={(index, item) => setVendaItems(prev => prev.map((it,i) => (item?._uid ? it._uid === item._uid : i===index) ? item : it))}
          onRemoverItem={(index, item) => setVendaItems(prev => prev.filter((it, i) => item?._uid ? it._uid !== item._uid : i !== index))}
          vendaEdicao={vendaEdicao}
          clientes={clientes}
          vendedores={vendedores}
          tiposPagamento={tiposPagamento}
          onSalvar={() => {
            setShowFormularioEdicao(false);
            setVendaEdicao(null);
            setProdutoSelecionado(null); // Limpar produto selecionado
            setVendaItems([]);
            fetchVendasProdutos(); // Recarregar lista
          }}
          onCancelar={() => {
            setShowFormularioEdicao(false);
            setVendaEdicao(null);
            setProdutoSelecionado(null); // Limpar produto selecionado
            setVendaItems([]);
          }}
          onAbrirPopupProdutos={() => {
            fetchProdutos();
            setShowPopupProdutos(true);
          }}
        />
      )}

      <LoadingOverlay isLoading={loading} message="Processando..." />
    </div>
  );
}
